import { KeyboardArrowLeft, Menu, Search } from "@mui/icons-material";
import {
  Box,
  OutlinedInput,
  InputAdornment,
  Drawer,
  Typography,
  InputBase,
  Chip,
  CircularProgress,
} from "@mui/material";
import MMenuDrawer from "components/MMenuDrawer";
import { homepageApi } from "features/homepage/homepageApi";
import { IKeywordSuggest } from "features/homepage/models";
import { ISearchFilter } from "features/searchStore/models";
import {
  searchStoreActions,
  selectFilter,
} from "features/searchStore/saga/searchStoreSlice";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { IValueLabel } from "utils/commonModels";

export function MHeaderSection() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const filter = useAppSelector(selectFilter);

  const [openMenu, setOpenMenu] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);

  const [loading, setLoading] = useState(false);
  const [keyword, setKeyWord] = useState<IValueLabel<string>>({
    value: "",
    label: "",
  });
  const [suggests, setSuggests] = useState<IKeywordSuggest[]>([]);
  const [keywordSend, setKeyWordSend] = useState<string>("");

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  const handleKeywordSearchChange = (e: any) => {
    setKeyWord(e.currentTarget.value);
    setKeyWordSend(e.currentTarget.value);
  };

  const handleSelectSuggest = (e: IValueLabel<string>) => {
    const filterValue: ISearchFilter = {
      ...filter,
      keyword: e,
    };
    dispatch(searchStoreActions.setSearchFilter(filterValue));
    setOpenSearch(false);
  };

  useEffect(() => {
    setLoading(true);
    keywordSend !== "" &&
      homepageApi
        .getSuggets({
          area_keyword: "",
          keyword: keywordSend,
          threshold: 0.4,
        })
        .then((e) => setSuggests(e.data.body.data))
        .catch((error) => console.log(error));
    setLoading(false);
  }, [keywordSend]);

  return (
    <>
      <Box display="flex">
        <Link to="/home">
          <Box
            width="110px"
            height="40px"
            component="img"
            src="/images/appIcon.png"
          />
        </Link>

        <Box
          display="flex"
          mx={1}
          // px={1}
          flex={1}
          alignItems="center"
          justifyContent="center"
        >
          <Box
            alignItems="center"
            display="flex"
            width="100%"
            sx={{
              bgcolor: "white",
              border: 1,
              borderRadius: 5,
              borderColor: "#0986CA",
              p: "2px 12px",
              cursor: "pointer",
              "&:hover": {
                borderColor: "#0986CA",
              },
            }}
            onClick={() => setOpenSearch(true)}
          >
            <Search sx={{ color: "#0986CA", marginRight: "8px" }} />
            <Box display="flex" flex={1}>
              {keyword.value === "" ? (
                <Typography
                  sx={{
                    color: "#0986CA",
                    opacity: 0.6,
                    fontStyle: "italic",
                  }}
                >
                  キーワード
                </Typography>
              ) : (
                <>{filter.keyword?.label}</>
              )}
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          justifyContent="end"
          color="#af9b65"
          px={2}
          alignItems="center"
        >
          <Box onClick={() => setOpenMenu(true)}>
            <Menu />
          </Box>
        </Box>
      </Box>
      <Drawer
        open={openSearch}
        onClose={() => setOpenSearch(false)}
        anchor="right"
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          py={2}
        >
          <Box
            display="flex"
            // position="absolute"
            // left="8px"
            alignItems="center"
            onClick={() => setOpenSearch(false)}
          >
            <KeyboardArrowLeft />
            <Typography fontWeight="bold">戻る</Typography>
          </Box>
          <Box
            display="flex"
            flex={1}
            mx={3}
            border={1}
            borderRadius="3px"
            bgcolor="white"
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="キーワード"
              value={keyword.label}
              onChange={handleKeywordSearchChange}
              onBlur={() => {
                setSuggests([]);
                setKeyWordSend("");
              }}
            />
          </Box>
        </Box>

        <Box sx={{ overflow: "auto", py: "16px" }}>
          {loading && (
            <Box display="flex">
              <CircularProgress />
            </Box>
          )}
          {suggests.map((e) => (
            <>
              <Chip
                key={e.value}
                label={e.label}
                sx={{ m: 1, zIndex: 8 }}
                clickable
                onMouseDown={() => handleSelectSuggest(e)}
              />
            </>
          ))}
        </Box>
      </Drawer>

      <MMenuDrawer isOpen={openMenu} handleClose={handleCloseMenu} />
    </>
  );
}
